export type AiProvider = "google" | "gpt" | "gemini" | "claude";

export const AI_PROVIDER_STORAGE_KEY = "gohan_memo_ai_provider";
export const DEFAULT_AI_PROVIDER: AiProvider = "google";
export const AI_PROVIDER_OPTIONS: AiProvider[] = ["google", "gpt", "gemini", "claude"];

export const AI_PROVIDERS: Record<
  AiProvider,
  { label: string; supportsPromptParam: boolean; buildUrl: (prompt: string) => string }
> = {
  google: {
    label: "Google検索",
    supportsPromptParam: true,
    buildUrl: (prompt) => `https://www.google.com/search?q=${encodeURIComponent(prompt)}`,
  },
  gpt: {
    label: "GPT",
    supportsPromptParam: true,
    buildUrl: (prompt) => `https://chatgpt.com/?q=${encodeURIComponent(prompt)}`,
  },
  gemini: {
    label: "Gemini",
    supportsPromptParam: false,
    buildUrl: () => "https://gemini.google.com/app",
  },
  claude: {
    label: "Claude",
    supportsPromptParam: true,
    buildUrl: (prompt) => `https://claude.ai/new?q=${encodeURIComponent(prompt)}`,
  },
};

export function getStoredAiProvider(): AiProvider | null {
  const value = localStorage.getItem(AI_PROVIDER_STORAGE_KEY);
  if (
    value === "google" ||
    value === "gpt" ||
    value === "gemini" ||
    value === "claude"
  ) {
    return value;
  }
  return DEFAULT_AI_PROVIDER;
}

export function setStoredAiProvider(provider: AiProvider) {
  localStorage.setItem(AI_PROVIDER_STORAGE_KEY, provider);
}

export function buildCaloriePrompt(foodName: string): string {
  return `${foodName} のカロリーは？`;
}